import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import PageLayout from 'examples/LayoutContainers/PageLayout';

function IllustrationLayout({ color, header, title, description, illustration, children }) {
  return (
    <PageLayout>
      <Grid container>
        <ArgonBox display="flex" flexDirection="column" justifyContent="center">
          <ArgonBox pt={3} px={3}>
            {!header ? (
              <>
                <ArgonBox mb={1}>
                  <ArgonTypography variant="h4" fontWeight="bold">
                    {title}
                  </ArgonTypography>
                </ArgonBox>
                <ArgonTypography variant="body2" fontWeight="regular" color="text">
                  {description}
                </ArgonTypography>
              </>
            ) : (
              header
            )}
          </ArgonBox>
          <ArgonBox p={3}>{children}</ArgonBox>
        </ArgonBox>
      </Grid>
    </PageLayout>
  );
}

IllustrationLayout.defaultProps = {
  color: 'info',
  header: '',
  title: '',
  description: '',
  illustration: {},
};

IllustrationLayout.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'info', 'success', 'warning', 'error', 'dark']),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  illustration: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default IllustrationLayout;
